import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import translate from '../../utils/translate';

import { ContentId, ProductView, TRACKING_TIMER, TrackingEventName } from '../../store/stores/tracking/types';

import { fullscreenStore, interiorStore, interiorStoreActions, rootStore, zoomStoreActions } from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import { testId } from '../../test-utils/constants';

const InteriorIcon = () => (
	<svg width="24" height="24" viewBox="10 10 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M12.8918 24.061C12.5124 24.2838 11.6301 24.8951 11.6301 25.77C11.6307 27.4994 15.5036 29.2876 21.9836 29.2876C22.2949 29.2876 22.5994 29.2802 22.9026 29.2719C22.565 28.9366 22.1257 28.5066 21.5403 27.9448L22.4612 26.9858C25.0062 29.4258 25.0129 29.518 25.0354 29.8198C25.054 30.1047 25.062 30.2338 22.8987 33.0014L21.8508 32.1831C22.3887 31.4952 22.7741 30.9878 23.0637 30.5991C22.7086 30.6104 22.3485 30.6177 21.9827 30.6177C14.9955 30.6176 10.3005 28.6691 10.3 25.77C10.3 24.2076 11.6422 23.2525 12.219 22.9145L12.8918 24.061ZM31.6272 22.9077C31.7098 22.9435 33.6106 23.8109 33.6106 25.7788C33.6103 27.7885 30.8985 29.6265 27.0149 30.2466L26.8059 28.9341C30.1874 28.3931 32.2801 26.8755 32.2805 25.7788C32.2805 24.6829 31.1347 24.1448 31.0842 24.1216L31.6272 22.9077ZM30.261 11.6665C29.9679 16.0485 29.2074 18.9897 28.4143 21.0063C27.6258 23.0112 26.7882 24.1199 26.4729 24.6665L26.2815 24.9985H17.0491L16.9016 24.5346L16.0657 21.895C15.8054 21.0729 16.2316 20.0121 17.2766 19.8823C18.515 19.7288 19.7206 19.9943 20.7629 20.1665C21.6767 20.3174 22.5132 20.4095 23.3586 20.2427V19.9546C23.3586 19.4738 23.5666 19.0072 23.7756 18.6128C23.9807 18.2259 24.2877 17.7366 24.5315 17.3081C25.0569 16.3847 25.5295 15.3538 25.5295 14.1196C25.5295 13.6463 25.5108 13.1695 25.4875 12.7632C25.433 11.8065 26.184 10.9575 27.1741 10.9575H30.3079L30.261 11.6665ZM27.1741 12.2876C26.9801 12.2876 26.8021 12.4617 26.8147 12.687C26.8388 13.1096 26.8596 13.6133 26.8596 14.1196C26.8596 15.7046 26.2466 16.9814 25.6868 17.9653C25.388 18.4904 25.1523 18.8549 24.9504 19.2358C24.7527 19.6091 24.6887 19.8251 24.6887 19.9546V21.2466L24.2239 21.393C22.8969 21.8116 21.6551 21.6622 20.5461 21.479C19.3986 21.2894 18.4377 21.079 17.4407 21.2026C17.4003 21.2076 17.3718 21.2245 17.3479 21.268C17.3196 21.3196 17.3055 21.4028 17.3342 21.4936L18.0227 23.6684H25.5276C25.9386 23.0173 26.5502 22.1102 27.176 20.519C27.8702 18.7539 28.5651 16.1588 28.8811 12.2876H27.1741Z"
			fill="#1B2236"
		/>
	</svg>
);

const ExteriorIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.5751 9.39701C16.5971 9.32301 17.5541 9.21401 18.4941 9.08501C18.3341 8.69501 18.0861 8.18001 17.7871 7.60501C15.8411 7.83701 13.8881 7.96401 11.9331 7.96401C10.0301 7.96401 8.12608 7.84401 6.22608 7.62401C5.92708 8.20001 5.67908 8.71701 5.51908 9.10401C6.51908 9.23301 7.52508 9.34401 8.52808 9.41301L8.43608 10.739C7.40408 10.668 6.36908 10.555 5.33908 10.421V14.003H7.57908V13.787V12.457L8.91008 12.457H15.1241H16.4531V13.787V14.003H18.6811V10.401C17.7101 10.534 16.7231 10.647 15.6711 10.724L15.5751 9.39701ZM8.39008 4.66301C8.00908 4.66301 7.94708 4.70701 7.49808 5.33401C7.30308 5.66301 7.10408 6.01001 6.90908 6.35801C10.3061 6.71401 13.7171 6.71001 17.1051 6.34301C16.9051 5.98501 16.7011 5.63001 16.5011 5.29501C16.1661 4.76101 16.0261 4.66301 15.5761 4.66301L8.39008 4.66301ZM20.4261 5.87901L20.6601 7.18801C20.245 7.26171 19.8278 7.32321 19.4108 7.38467C19.3356 7.39576 19.2603 7.40685 19.1851 7.41801C19.6361 8.31701 20.0111 9.18601 20.0111 9.58601V14.146C20.0111 14.802 19.4861 15.333 18.8391 15.333H16.2961C15.6471 15.333 15.1241 14.802 15.1241 14.146V13.787H8.91008V14.138C8.91008 14.794 8.37808 15.333 7.73008 15.333L5.18108 15.333C4.53408 15.333 4.00908 14.802 4.00908 14.146L4.00908 9.58601C4.00908 9.19201 4.37908 8.33501 4.82608 7.44101C4.75092 7.43016 4.67573 7.41939 4.60053 7.40861C4.19047 7.34984 3.77992 7.29099 3.37008 7.22001L3.59908 5.90901C4.22508 6.01901 4.85208 6.11001 5.48008 6.19501C5.96608 5.30901 6.38408 4.60601 6.38408 4.60601C6.39096 4.59639 6.39783 4.5868 6.40468 4.57721C6.8818 3.9103 7.29481 3.33301 8.39008 3.33301L15.5761 3.33301C16.7571 3.33301 17.2421 3.97401 17.6431 4.61301C17.6431 4.61301 18.0541 5.30201 18.5321 6.17501C19.1641 6.08801 19.7961 5.99101 20.4261 5.87901ZM11.206 10.0704C11.206 10.5214 11.567 10.8874 12.014 10.8874C12.46 10.8874 12.822 10.5214 12.822 10.0704C12.822 9.61841 12.46 9.25241 12.014 9.25241C11.567 9.25241 11.206 9.61841 11.206 10.0704ZM16.8544 18.9185L17.0654 20.2305C20.9484 19.6095 23.6604 17.7715 23.6604 15.7625C23.6604 13.7935 21.7574 12.9265 21.6764 12.8915L21.1334 14.1055C21.1824 14.1275 22.3304 14.6665 22.3304 15.7625C22.3304 16.8585 20.2364 18.3765 16.8544 18.9185ZM12.509 16.9688C15.055 19.4088 15.063 19.5078 15.084 19.8038V19.8039C15.105 20.0948 15.1137 20.2152 12.948 22.9858L11.9 22.1648C12.434 21.4828 12.821 20.9748 13.113 20.5828C12.758 20.5948 12.398 20.6018 12.032 20.6018C5.04398 20.6018 0.349976 18.6538 0.349976 15.7538C0.349976 14.1888 1.69198 13.2358 2.26898 12.8978L2.93998 14.0458C2.56098 14.2678 1.67998 14.8768 1.67998 15.7538C1.67998 17.4838 5.55198 19.2718 12.032 19.2718C12.344 19.2718 12.649 19.2648 12.952 19.2558C12.614 18.9208 12.175 18.4918 11.589 17.9298L12.509 16.9688Z"
			fill="#1B2236"
		/>
	</svg>
);

export const InteriorToggleButton = () => {
	const isInteriorMode = use$(interiorStore.isInteriorLoaded);
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
	const [_, currentModelValue] = use$(rootStore.currentModel);

	const interiorEntries = Object.entries(currentModelValue.interior || {});

	if (!interiorEntries.length) return null;

	const handleToggle = () => {
		zoomStoreActions.resetZoom();

		if (isInteriorMode) {
			interiorStoreActions.setIsInteriorLoaded(false);
			trackingStore.setTrackingTimer(
				TRACKING_TIMER.PRODUCTVIEW_INTERIOR_NAME,
				TrackingEventName.VISUALIZER_MENU_CLICK,
				{
					contentId: ContentId.MENU,
					sectionName: ProductView.INTERIOR_VIEW
				}
			);
			return;
		}

		const [previousInteriorKey] = interiorStore.currentInterior.get();
		const preservedInterior = currentModelValue.interior?.[previousInteriorKey];
		const [interiorKey, interiorValue] = preservedInterior
			? ([previousInteriorKey, preservedInterior] as const)
			: interiorEntries[0]!;

		interiorStoreActions.setInteriorData([interiorKey, interiorValue.assets]);
		interiorStoreActions.setIsInteriorLoaded(true);
		trackingStore.setTrackingTimer(
			TRACKING_TIMER.PRODUCTVIEW_INTERIOR_NAME,
			TrackingEventName.VISUALIZER_INTERIOR_CLICK,
			{
				sectionName: ProductView.INTERIOR_VIEW,
				contentId: ContentId.MENU
			}
		);
	};

	return (
		<ToggleButton
			tag="button"
			emphasis="tertiary"
			data-testid={testId('Interior_Toggle_Button')}
			aria-label={
				isInteriorMode ? translate('global.ariaLabel.exitInterior') : translate('global.ariaLabel.switchToInterior')
			}
			aria-pressed={isInteriorMode}
			$isFullscreen={isFullscreenMode}
			onClick={handleToggle}
			icon={isInteriorMode ? <ExteriorIcon /> : <InteriorIcon />}
		/>
	);
};

const ToggleButton = styled(CTA)<{ $isFullscreen: boolean }>`
	position: absolute;
	z-index: 5;
	bottom: 12px;
	inset-inline-start: 12px;

	&& {
		width: 46px;
		height: 46px;
		min-width: 46px;
		min-height: 46px;
		padding: 0;
		margin: 0;
		border: none;
		border-radius: 50%;
		overflow: hidden;
		-webkit-tap-highlight-color: transparent;
		transition: background 0.2s;
	}

	&&,
	&&:hover,
	&&:active,
	&&:focus {
		background: #ffffff;
		color: #1b2236;
	}

	&& svg,
	&& svg [stroke] {
		color: #1b2236;
	}

	&& svg {
		display: block;
		width: 24px;
		height: 24px;
	}

	@media (min-width: ${Breakpoints.b960}px) {
		bottom: 16px;
		inset-inline-start: 16px;
	}

	@media (hover: hover) {
		&&:hover {
			background: #ccbdab;
		}
	}

	&&:focus-visible {
		outline: 2px solid #c86c03;
	}

	${({ $isFullscreen }) => $isFullscreen && 'top: 16px; bottom: auto;'}
`;
